export default __webpack_public_path__ + "static/media/sr.45463ee6.svg";